import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { BatchService } from '../../services/batch.service';
import { CreateBatchComponent } from "../../components/Batch/create-batch/create-batch.component";
import { DeleteBatchComponent } from "../../components/Batch/delete-batch/delete-batch.component";
import { CourseService } from 'src/app/private/services/course.service';
import { AcademicYearService } from 'src/app/private/services/acedemicyear.service';
import { UsersService } from 'src/app/private/services/users.service';

@Component({
  selector: 'app-batch-configuration',
  imports: [SharedModule, ToolBarComponent, CreateBatchComponent, DeleteBatchComponent],
  templateUrl: './batch-configuration.component.html',
  styleUrl: './batch-configuration.component.scss'
})
export class BatchConfigurationComponent {

  dataSource: any[] = [];
  totalRecords: number = 0;
  rows: number = 10;
  initialLoad: boolean = true;
  loading: boolean = false;
  filterArray: any[] = [];
  isAddBatch: boolean = false;
  isEditBatch: boolean = false;
  isDeleteBatch: boolean = false;
  batchData: any;

  items: any[] = [];

  columns: any[] = [
    { field: 'batch_name', header: 'Batch Name' },
    { field: 'academic_year.year_name', header: 'Academic Year', type: 'academic_year' },
    { field: 'course.name', header: 'Course', type: 'course' },
    { field: 'user.fname', header: 'Faculty', type: 'user' },
    { field: 'start_date', header: 'Start Date', type: 'date' },
    { field: 'end_date', header: 'End Date', type: 'date' },
    { field: 'max_students', header: 'Max Students' },
    { field: 'batch_status', header: 'Status' },
    { field: 'actions', header: 'Actions', type: 'actions' }
  ];

  allCourses: any[] = [];
  allAcademicYears: any[] = [];
  allUsers: any[] = [];

  constructor(
    private api: BatchService,
    private courseApi: CourseService,
    private acedemicYearApi: AcademicYearService,
    private userApi: UsersService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }



  ngOnInit() {
    this.getAllCourses();
    this.getAllAcademicYears();
    this.getAllUsers();
  }

  getAllCourses() {
    const param = {
      "organization_id": this.localStorage.getOrganizationId(),
      "campus_id": this.localStorage.getCampusId(),
      "status": "Active"
    }

    this.courseApi.getAllCourses(param).subscribe({
      next: (data) => {

        this.allCourses = data || [];
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load courses.' });
      },
    });
  }


  getAllAcademicYears() {
    const param = {
      "organization_id": this.localStorage.getOrganizationId(),
      "campus_id": this.localStorage.getCampusId()
    }

    this.acedemicYearApi.getAllAcademicYears(param).subscribe({
      next: (data) => {
        this.allAcademicYears = data || [];
      },
      error: () => {

        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load academic years.' });
      },
    });
  }


  getAllUsers() {
    const param = {
      "organization_id": this.localStorage.getOrganizationId(),
    }

    this.userApi.findAllUsers(param).subscribe({
      next: (data) => {
        this.allUsers = data || [];
        this.allUsers = this.allUsers.map((user: any) => {
          return {
            label: user.fname + ' ' + user.lname,
            value: user.user_id
          }
        });
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load users.' });
      }
    });
  }



  batchActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Batch',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isEditBatch = true;
          }
        },
        {
          label: 'Delete Batch',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteBatch = true;
          }
        }
      ]
    }
  ]


  setBatchData(rowData: any) {
    this.batchData = rowData;
  }


  loadData(event: any) {
    const page = event.first || 0;
    const size = event.rows || this.rows;

    const param = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "campus_id": this.localStorage.getCampusId()
      },
      "filter": null,
      "page": page,
      "limit": size,
      "order": {
        "col": "\"batche\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    this.loading = true;

    this.api.getAllBatchesWithCount(param).subscribe({
      next: (data) => {
        this.dataSource = data.rows || [];
        this.totalRecords = data.count || 0;
        this.loading = false;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load academic years.' });
        this.initialLoad = false;
        this.loading = false;
      },
    });
  }

  reloadData() {
    this.loadData({ first: 0, rows: this.rows });
  }

    getFullName(user: any) {
    return [user?.prefix, user?.fname, user?.lname]
      .filter(name => !!name)
      .join(' ');
  }

  handleAddBatch() {
    this.isAddBatch = true;
  }

  handleCloseDialog() {
    this.isAddBatch = false;
  }


}
